import React from 'react';
import PropTypes from 'prop-types';
import createHeaderColumn from './createHeaderColumn';
import createRow from './createRow';

const Table = ({columnHeaders, rows}) => {
    return(
        <table className="table table-responsive">
            <thead>
                <tr key={"header"}>
                    {columnHeaders.map((header,key) => createHeaderColumn(header,key.toString()))}
                </tr>
            </thead>
            <tbody>
                {rows.map((r,k) => createRow(r,k.toString()))}
            </tbody>
        </table>
    );
};

Table.propTypes = {
    columnHeaders: PropTypes.array.isRequired,
    rows: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Table;


// WEBPACK FOOTER //
// ./src/common/table/Table.js